<div class="paginator-container w-full flex flex-row justify-between items-center border-t border-gray-200">
  <div class="w-fit flex flex-row justify-start items-center gap-1">
    <ts-button
      variant="paginator"
      htmlButtonType="button"
      class="backward-button paginator-nav-button"
      [disabled]="activePage === 1"
      (buttonClick)="changeActivePage(activePage - 1)"
    >
      <ts-icon icon="chevron_left"></ts-icon>
    </ts-button>

    <ng-container *ngFor="let page of rowButtons">
      <ng-container *ngIf="page === '...'; else pageButton">
        <p class="ellipsis">{{ page }}</p>
      </ng-container>
      <ng-template #pageButton>
        <ts-button
          variant="paginator"
          htmlButtonType="button"
          [active]="page === activePage"
          (buttonClick)="changeActivePage(page)"
        >
          {{ page }}
        </ts-button>
      </ng-template>
    </ng-container>

    <ts-button
      variant="paginator"
      htmlButtonType="button"
      class="forward-button paginator-nav-button"
      [disabled]="activePage === totalPages || totalPages === 0"
      (buttonClick)="changeActivePage(activePage + 1)"
    >
      <ts-icon icon="chevron_right"></ts-icon>
    </ts-button>
  </div>

  <div class="flex flex-row justify-start items-center gap-2 items-per-page" *ngIf="!hidePageSize">
    <p class="text-sm">Items per page</p>
    <mat-form-field appearance="fill">
      <mat-select [formControl]="pageSizeControl">
        <mat-option *ngFor="let itemsPerPageOption of pageSizeOptions" [value]="itemsPerPageOption"
          >{{ itemsPerPageOption }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
